/** Notes page and editor copy. EN mirrors SV until proper translations are added. */
export const notesTranslationsSv = {
    title: 'Anteckningar',
    description: 'Dina anteckningar på emissioner, teckningsoptioner och konvertibler.',
    expandAll: 'Visa hela anteckningarna',
    columns: {
        name: 'Namn',
        updated: 'Uppdaterad',
        note: 'Anteckning',
    },
    errors: {
        couldNotRead: 'Kunde inte läsa anteckningen.',
        couldNotLoad: 'Kunde inte hämta anteckningarna.',
        couldNotDelete: 'Kunde inte ta bort anteckningen.',
        couldNotSave: 'Kunde inte spara anteckningen.',
    },
    deleteConfirm: {
        message: 'Är du säker på att du vill ta bort anteckningen?',
        title: 'Ta bort anteckning',
        confirmLabel: 'Ta bort',
    },
    editor: {
        title: 'Anteckning',
        placeholder: 'Skriv en anteckning...',
        tooltip: 'Anteckning',
        ariaLabel: 'Anteckning',
    },
}
